import { render, staticRenderFns } from "./MenuOfgroupManage.vue?vue&type=template&id=a808b1e2&scoped=true&"
import script from "./MenuOfgroupManage.vue?vue&type=script&lang=js&"
export * from "./MenuOfgroupManage.vue?vue&type=script&lang=js&"
import style0 from "./MenuOfgroupManage.vue?vue&type=style&index=0&id=a808b1e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a808b1e2",
  null
  
)

export default component.exports